module.exports = __webpack_public_path__ + "7f3c53e67bb8d9cfe5c55164b66db19e.png";